<script lang="ts" setup>
import { tryMenuNavigation } from '../../urlHelper';
</script>

<template>
  <a
    class="items-center gap-ch text-sm text-inherit hover:underline"
    href="/net/home/about"
    @click="tryMenuNavigation"
  >
    <strong>Vragen?</strong>
    Bel ons op (072) 30 35 900
  </a>
</template>
